import React from "react";
import MainLayout from "../../components/Layout/MainLayout";
import { newsItems } from "./newsData";
import { news } from "../../styles/theme"; // New styles



const News = () => {
  return (
    <MainLayout>
      <section style={news.section}>
        <h1 style={news.title}>News & Updates</h1>

        {newsItems.map((item, idx) => (
          
          <article key={idx} style={news.card}>

            <div style={news.cardHeader}>
              <span style={news.date}>{item.date}</span>

              {item.tags && (
                <div style={news.tags}>
                  {item.tags.map((tag, i) => (
                    <span key={i} style={news.tag}>
                      {tag}
                    </span>
                  ))}
                </div>
              )}
            </div>

            <h2 style={news.itemTitle}>
              {item.link ? (
                <a href={item.link} style={news.link}>
                  {item.title}
                </a>
              ) : (
                item.title
              )}
            </h2>

            <p style={news.summary}>{item.summary}</p>

            {/* Optional image */}
            {item.image && (
              <div style={{ overflow: "hidden", borderRadius: "8px", marginBottom: "16px" }}>
                <img src={item.image} alt={item.title} style={news.image} />
              </div>
            )}

            {/* Separate Link Button */}
            {item.link && (
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                style={news.linkButton}
              >
                View Details →
              </a>
            )}

          </article>
        ))}
      </section>
    </MainLayout>
  );
};

export default News;